import {
  Box,
  Button,
  Card,
  DialogActions,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Log,
  approvePendingGroup,
  getGroupDetailsWithActions,
  getPendingGroupList,
} from "../../services/services";
import ListHead from "../table/ListHead";
import Scrollbar from "../table/Scrollbar";
import RejectPendingGroup from "./Dialogs/RejectPendingGroup";
import { applySortFilter } from "../../utils/tableFunctions";
import { StyledTableRow } from "../TableRow";
import { useLoadingSpinnerContext } from "../../context/loadingSpinnerContext";
import { CustomTableCell } from "../TableCell";
import CommonDialog from "../CustomDialog";
import GroupDetails from "../../pages/details/admin/GroupDetails";
import CircularLoader from "../circularLoader";
import { styles } from "../../utils/styles";
import Pagination from "../Pagination";
import { pageNumber, rowsPerPage } from "../../utils/constants";

const TABLE_HEAD = [
  { id: "name", label: "Name" },
  { id: "action", label: "Action" },
  { id: "approve" },
];

const PendingGroup = ({ userRole }) => {
  const { setGlobalLoading } = useLoadingSpinnerContext();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [groupList, setGroupList] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [pendingDetails, setPendingDetails] = useState(null);

  const [pagination, setPagination] = useState({
    page: pageNumber,
    page_size: rowsPerPage,
  });

  // dialogs
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [selectedId, setSelectedId] = useState();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredList = applySortFilter(
    groupList?.results || [],
    order,
    orderBy
  );

  const isItemNotFound = filteredList.length === 0;

  const queryPage = (queryParams) => {
    setLoaded(false);
    getPendingGroupList({
      setResponse: setGroupList,
      setLoaded: setLoaded,
      filter: {},
      queryParams: queryParams,
    });
    setPagination(queryParams);
  };

  const handleChangePage = (event, newPage) => {
    queryPage({
      page: newPage,
      page_size: pagination.page_size,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    queryPage({
      page: 1,
      page_size: parseInt(event.target.value, 10),
    });
  };

  useEffect(() => {
    queryPage(pagination);
  }, []);

  const handleCloseDialog = (shouldResetDetails) => {
    setOpenRejectDialog(false);
    if (shouldResetDetails === true) setPendingDetails(null);
  };
  return (
    <Box>
      {loaded ? (
        <Card>
          <Scrollbar>
            <TableContainer>
              <Table>
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                  checkbox={false}
                />

                <TableBody>
                  {loaded &&
                    filteredList.map((row) => {
                        const { id, name, action } = row;

                        return (
                          <StyledTableRow
                            hover
                            key={id}
                          >
                            <CustomTableCell field={name} />
                            <CustomTableCell field={action} />
                            <TableCell>
                              <Button
                                variant="text"
                                color="secondary"
                                onClick={() => {
                                  setGlobalLoading(true);
                                  getGroupDetailsWithActions(id, setPendingDetails, () => setGlobalLoading(false));
                                }}
                              >
                                View Detail
                              </Button>
                            </TableCell>
                          </StyledTableRow>
                        );
                      })}
                </TableBody>
                {isItemNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper>
                          <Typography
                            gutterBottom
                            align="center"
                            variant="subtitle1"
                          >
                            There is no pending group at the moment.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          {!isItemNotFound && (
            <Pagination
              count={groupList?.count || 0}
              pagination={pagination}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Card>
      ) : (
        <CircularLoader />
      )}
      {selectedId && (
        <RejectPendingGroup
          open={openRejectDialog}
          onClose={handleCloseDialog}
          selectedId={selectedId}
          setGroupList={setGroupList}
          setLoaded={setLoaded}
          pagination={pagination}
        />
      )}

      {pendingDetails && (
        <CommonDialog
          title="Group Details"
          onClose={() => setPendingDetails(null)}
          renderActions={() =>
            userRole.includes("Approve/Reject") && (
              <DialogActions>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setOpenRejectDialog(true);
                    setSelectedId(pendingDetails[0].id);
                  }}
                >
                  Reject
                </Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    setGlobalLoading(true);
                    Log.info(`Click button [Approve] - Approve Group role by Id: ${pendingDetails[0].id}`, {})
                    await approvePendingGroup(
                      pendingDetails[0].id,
                      setGroupList,
                      setLoaded,
                      pagination
                    )
                    setPendingDetails(null);
                    setGlobalLoading(false);
                  }}
                  sx={{ ...styles.customButton }}
                >
                  Approve
                </Button>
              </DialogActions>
            )
          }
        >
          <GroupDetails detailsData={pendingDetails} />
        </CommonDialog>
      )}
    </Box>
  );
};

export default PendingGroup;
